module.exports = __webpack_public_path__ + "img/GCvs107.0a7921a9.png";